import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './csp-styles.css';

const cspNonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');
const emotionCache = createCache({ key: 'fms', nonce: cspNonce || undefined });

ReactDOM.render((
  <CacheProvider value={emotionCache}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </CacheProvider>
), document.getElementById('root'));

serviceWorker.unregister();
